<template>
  <div class="home">
    <div></div>
    <div class="info_box">
      <div class="info_left">
        <div class="userInfo">
          <div class="tx_box">
<!--            <img v-if="imageUrl" :src="url + imageUrl" alt />-->
<!--            <img v-else src="../../assets/img/home/girl.jpg" alt />-->
<!--            &lt;!&ndash; <div class="changeImg">-->
<!--              <div @click.stop="uploadHeadImg">修改头像</div>-->
<!--            </div> &ndash;&gt;-->
<!--            <input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />-->
            <div v-if="parseInt(userSex) == 1">
              <!--<div class="name" style="padding-top: 15px;font-size: 20px;">{{ userInfo.username }}</div>-->
              <img
                  class="gender"
                  src="../../assets/img/home/girl.jpg"
                  style="margin-top:15px;width: 105px; height: 105px; float: left!important;"
              />
            </div>
            <div v-else>
              <img
                  class="gender"
                  src="../../assets/img/home/boy.jpg"
                  style="margin-top:15px;width: 105px; height: 105px;float: left!important;"
              />
            </div>
          </div>
          <div class="name">{{ trueName }}</div>
        </div>
        <!-- 功能列表 -->
        <div class="per_list">
          <div
            @click="changeTab(index)"
            :class="{ current: current == index }"
            v-for="(item, index) in perList"
            :key="index"
            class="per_item"
          >
            <!-- <div v-if="index == 1 || index == 2">
              <div class="badeg"></div>
            </div>-->
            {{ item }}
          </div>
        </div>
      </div>
      <div class="info_right">
        <!-- 账户设置 -->
        <Zhanghu :message="clickData" v-if="current == 0"></Zhanghu>
        <!-- 消息中心 -->
        <MsgCenter v-if="current == 1"></MsgCenter>
        <!-- 我的答疑 -->
        <MyAnswer v-if="current == 2"></MyAnswer>
        <!-- 我的笔记 -->
        <MyNote v-if="current == 3"></MyNote>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "../../bus.js";
import store from "store";
// import { myNote } from "../../assets/js/api.js";
import Zhanghu from "@/components/personal/zhanghu.vue";
import MsgCenter from "@/components/personal/msgCenter.vue";
import MyAnswer from "@/components/personal/myAnswer.vue";
import MyNote from "@/components/personal/myNote.vue";
export default {
  components: {
    Zhanghu,
    MsgCenter,
    MyAnswer,
    MyNote,
  },
  data() {
    return {
      url: ".",
      current: 0,
      imageUrl: "",
      perList: ["账户设置", "消息中心", "我的答疑", "我的笔记"],
      username: "",
      userSex:"",
      trueName: "",
      clickData: "",
    };
  },
  mounted() {
    // this.current =this.$route.query.type
    this.username = localStorage.getItem("userInfo").username ;//store.get("username");
    this.trueName = localStorage.getItem("truename") ;//store.get("username");
    this.userSex = localStorage.getItem("user.sex");
    if (store.get("current")) {
      this.current = store.get("current");
    } else {
      this.current = 0;
      this.clickData = 0;
      // store.set("activeTabs", 0);
    }
    window.scroll(0, 0);
    Bus.$on("userInfo", (data) => {
      console.log("userInfo"+data);
      this.imageUrl = store.get("header_img");
      this.username = data.username;
      store.set("username", this.username);
    });

  },
  methods: {


    changeTab(i) {
      this.current = i;
      store.set("current", i);
      store.set("activeTabs", 0);
    },
    uploadHeadImg: function () {
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile: function (e) {
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.imageUrl = res.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  // padding: 60px !important;
  // padding-top: 20px!important;
  // box-sizing: border-box;
  margin-top: 100px !important;
}
.current {
  color: #029aff !important;
  border-left: 4px solid #029aff !important;
  background-color: #f5f5f5 !important;
}
.info_box {
  width: 1200px;
  margin: 40px auto;
  margin-top: 40px;
  display: flex;
  .info_left {
    width: 250px;
    height: 586px;
    border: 1px solid #dedede;
    margin-right: 30px;
    padding: 30px 0;
    box-sizing: border-box;
    .userInfo {
      text-align: center;
      .tx_box {
        width: 130px;
        height: 130px;
        border-radius: 50%;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;
        }
        .changeImg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 40px;
          line-height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          border-radius: 0 0 200px 200px;
        }
      }
      .name {
        font-size: 20px;
        color: #343434;
        margin-top: 15px;
      }
    }
    .per_list {
      margin-top: 40px;
      .per_item {
        position: relative;
        text-align: center;
        width: 100%;
        height: 80px;
        line-height: 80px;
        font-size: 20px;
        color: #343434;
        cursor: pointer;
        .badeg {
          position: absolute;
          top: 30px;
          right: 55px;
          width: 8px;
          height: 8px;
          background: #ff0001;
          border-radius: 50%;
        }
      }
    }
  }
  .info_right {
    position: relative;
    width: 100%;
    margin-bottom: 50px;
    // background-color: pink;
  }
}
</style>
